/* __next_internal_client_entry_do_not_use__ SDUIBrandInsightsTileRenderer auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { EventOrigin } from "@faire/retailer-visitor-shared/features/InsightsFeed/events";
import { InsightCardContext, InsightCardContextProvider } from "@faire/retailer-visitor-shared/features/InsightsFeed/InsightCardContext";
import { MuteModal } from "@faire/retailer-visitor-shared/features/InsightsFeed/MuteModal";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
import React, { useContext, useState } from "react";
import { BrandInsightsTileContents } from "./BrandInsightsTile/BrandInsightsTileContents";
import { MutedBrandInsightsTileContents } from "./BrandInsightsTile/MutedBrandInsightsTileContents";
export var SDUIBrandInsightsTileRenderer = function(props) {
    return /*#__PURE__*/ _jsx(InsightCardContextProvider, {
        origin: getEventOrigin(props.loggingData),
        children: /*#__PURE__*/ _jsx(SDUIBrandInsightsTileRendererBase, _object_spread({}, props))
    });
};
var SDUIBrandInsightsTileRendererBase = function(param) {
    var tileElement = param.tileElement, loggingData = param.loggingData;
    var _useState = _sliced_to_array(useState(false), 2), isMuteModalOpen = _useState[0], setIsMuteModalOpen = _useState[1];
    var _useContext = useContext(InsightCardContext), mutedBrands = _useContext.mutedBrands, onChangeMute = _useContext.onChangeMute, containerOrigin = _useContext.containerOrigin;
    var _tileElement_brand_insights_tile;
    var metadata = ((_tileElement_brand_insights_tile = tileElement.brand_insights_tile) !== null && _tileElement_brand_insights_tile !== void 0 ? _tileElement_brand_insights_tile : {}).metadata;
    var _metadata_brand_token;
    var isMuted = (mutedBrands !== null && mutedBrands !== void 0 ? mutedBrands : []).includes((_metadata_brand_token = metadata === null || metadata === void 0 ? void 0 : metadata.brand_token) !== null && _metadata_brand_token !== void 0 ? _metadata_brand_token : "");
    var _metadata_brand_name, _metadata_brand_token1, _metadata_brand_name1;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isMuteModalOpen ? /*#__PURE__*/ _jsx(MuteModal, {
                brandName: (_metadata_brand_name = metadata === null || metadata === void 0 ? void 0 : metadata.brand_name) !== null && _metadata_brand_name !== void 0 ? _metadata_brand_name : "",
                brandToken: (_metadata_brand_token1 = metadata === null || metadata === void 0 ? void 0 : metadata.brand_token) !== null && _metadata_brand_token1 !== void 0 ? _metadata_brand_token1 : "",
                isMuted: isMuted,
                onChangeMute: onChangeMute,
                onClose: function() {
                    return setIsMuteModalOpen(false);
                },
                containerOrigin: containerOrigin !== null && containerOrigin !== void 0 ? containerOrigin : ""
            }) : null,
            /*#__PURE__*/ _jsx("div", {
                className: "flex w-[312px]",
                "data-testid": "sdui-brand-insights-tile",
                children: isMuted ? /*#__PURE__*/ _jsx(MutedBrandInsightsTileContents, {
                    brandName: (_metadata_brand_name1 = metadata === null || metadata === void 0 ? void 0 : metadata.brand_name) !== null && _metadata_brand_name1 !== void 0 ? _metadata_brand_name1 : "",
                    onUndoMuteClick: function() {
                        return setIsMuteModalOpen(true);
                    }
                }) : /*#__PURE__*/ _jsx(BrandInsightsTileContents, {
                    tileElement: tileElement,
                    loggingData: loggingData,
                    onMuteClick: function() {
                        return setIsMuteModalOpen(true);
                    }
                })
            })
        ]
    });
};
var getEventOrigin = function(loggingData) {
    // right now home page is the only surface that uses SDUI Insights Tile
    if (loggingData.view_display_page === DisplayPageType.HOMEPAGE) {
        return EventOrigin.HomeFeed;
    }
    return EventOrigin.Unknown;
};
